import React from "react";
import { Outlet } from "react-router-dom";
import { LearnProgressProvider } from "../components/learn/LearnProgressProvider";
import { LearnCloudTransitionProvider } from "../components/learn/PixleyCloudTransition";

/**
 * One parent for every /learn route: a single progress store for the whole
 * Learn tree (one fetch per profile, shared writes) and the cloud transition
 * overlay that must survive navigation between maps and games.
 */
export default function LearnLayout() {
  return (
    <LearnProgressProvider>
      <LearnCloudTransitionProvider>
        <Outlet />
      </LearnCloudTransitionProvider>
    </LearnProgressProvider>
  );
}
